import { Action } from '@ngrx/store';

export const TAKE_PHOTO = '[Camera Modal] Take Photo';
export const TAKE_PHOTO_FAIL = '[Camera Modal] Take Photo Fail';

export class TakePhotoAction implements Action {
    readonly type = TAKE_PHOTO;

    constructor(public payload: {
        accountId: string,
        jobId: string,
        mimeType: string,
        name: string,
        path: string,
        size: number
    }) {
    }
}

export class TakePhotoFailAction implements Action {
    readonly type = TAKE_PHOTO_FAIL;

    constructor(public payload: {error: Error}) {
    }
}

export type Actions
    = TakePhotoAction
    | TakePhotoFailAction;



// WEBPACK FOOTER //
// ./src/app/modals-popovers/camera-modal/camera-modal.actions.ts